import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/index'
import aboutUs from "@/views/aboutUs"
import servesProduct from "@/views/servesProduct"
import newsList from "@/views/newsList"
import newsDetails from '@/views/newsDetails'

Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            name: '业务领域',
            component: Index
        },
        {
            path: "/servesProduct",
            name: "服务产品",
            component: servesProduct
        },
        {
            path: "/aboutUs",
            name: "关于我们",
            component: aboutUs
        },
        {
            path: "/newsList",
            name: "新闻列表",
            component: newsList
        }, {
            path: "/newsDetails",
            name: "新闻详情",
            component: newsDetails
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js